module.exports = __webpack_public_path__ + "img/chevron-right-pagination.a2ca74e3.svg";